import { Box, IconButton, Typography } from '@mui/material'
import { FC, useState } from 'react'

// components import
import { CardBox } from '../../../theme/styleComponents'
import { DisplayNotesTab } from '../../caseDetail/caseNotes/DisplayNotesTab'
import { DeleteNote } from '../../caseDetail/caseNotes/DeleteNoteModal'

// others
import { NotesPayload } from '../../../../generated'
import { EditNote } from '../../caseDetail/caseNotes/EditNoteModal'
import { CaseContextProvider } from '../../../context'
import CreateBillingNoteModal from './modal/CreateBillingNoteModal'
import AddIcon from '@mui/icons-material/Add'
import { flexCenter, flexJustifySpaceBetween } from '../../../theme/styleConstants'
import useFetchCaseNotes from '../../../hooks/useFetchCaseNotes'

interface BillNotesCardProps {
  caseId: string
}

const BillNotesCard: FC<BillNotesCardProps> = ({ caseId }) => {
  const { notes, refetch } = useFetchCaseNotes({ caseId, noteTypes: ['billing', 'staff'] })
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)

  const handleClickOpen = () => {
    setIsOpenCreateModal(true)
  }

  return (
    <CardBox mb={3}>
      <Box
        sx={{
          p: 3,
          borderBottom: '1px solid #E4E7EC',
          ...flexCenter,
          ...flexJustifySpaceBetween
        }}
      >
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          Bill Notes
        </Typography>

        <IconButton onClick={handleClickOpen} aria-label="add note">
          <AddIcon />
        </IconButton>
      </Box>

      {notes?.length ? (
        <Box sx={{ p: 2 }}>
          <CaseContextProvider>
            <DisplayNotesTab notes={notes as NotesPayload['notes']} refetchAllNotes={refetch} />

            <DeleteNote refetchAllNotes={refetch} />
            <EditNote refetchAllNotes={refetch} />
          </CaseContextProvider>
        </Box>
      ) : (
        <></>
      )}

      {isOpenCreateModal && (
        <CreateBillingNoteModal
          isOpen={isOpenCreateModal}
          caseId={caseId}
          refetch={refetch}
          handleClose={() => setIsOpenCreateModal(false)}
        />
      )}
    </CardBox>
  )
}

export default BillNotesCard
